import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import MainTemplate from 'pages/templates/MainTemplate';
import MbTabs from 'components/organisms/MbTabs';
import ProductManagementGoodsInfoList from './ProductManagementGoodsInfoList'; //일반상품수집현황
import ProductManagementGoodsInfoReviewAdver from './ProductManagementGoodsInfoReviewAdver'; //상품리뷰수집현황 (광고주현황)
import ProductManagementGoodsInfoReviewProcut from './ProductManagementGoodsInfoReviewProcut'; //상품리뷰수집현황 (상품현황)
import AiCategory from './AiCategory'; // AI연구소 카테고리 [카테고리별]
import AiCategoryProduct from './AiCategoryProduct'; // AI연구소 카테고리 [상품별]
import SmartMaterialManagement from './SmartMaterialManagement'; // AI연구소 상품 카테고리 ,
// import GoodsNot from './GoodsNot'; //광고수집 중지 광고주

const ProductManagementGoodsInfo = () => {
  let { path } = useRouteMatch();
  const { menu } = useSelector(({ menu }) => ({
    menu: menu.list === null ? new Map() : menu.list,
  }));

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };

  return (
    <MainTemplate>
      <MbTabs
        name="ProductManagementGoodsInfo"
        tabMenuList={tabList()}
        tabs={{
          '/product/collection/goodsinfo': {
            tabComponent: <ProductManagementGoodsInfoList />,
          },
          '/product/collection/goodsinfo/reviewAdver': {
            tabComponent: <ProductManagementGoodsInfoReviewAdver />,
          },
          '/product/collection/goodsinfo/reviewProduct': {
            tabComponent: <ProductManagementGoodsInfoReviewProcut />,
          },
          '/product/collection/aiCategory/product': {
            tabComponent: <AiCategoryProduct />,
          },
          '/product/collection/aiCategory/category': {
            tabComponent: <AiCategory type="category" />,
          },
          '/product/collection/goodsinfo/smartRtb': {
            tabComponent: <SmartMaterialManagement />,
          },
        }}
      />
    </MainTemplate>
  );
};

export default ProductManagementGoodsInfo;
